import { ReactElement } from 'react';

import { FontWeights } from '../../utils/typography/types';
import Hr from '../Hr';
import { HeaderElements } from '../Text/types';
import { HeaderWithRuleContainer, HeaderWithRuleText } from './styles';
import { HeaderWithRuleProps } from './types';

const HeaderWithRule = ({
	textWeight = FontWeights.Regular,
	textColor = 'black',
	hrWeight,
	hrColor,
	hrOpacity,
	el,
	fontSize,
	children,
}: HeaderWithRuleProps): ReactElement => {
	const hrProps = {
		weight: hrWeight,
		color: hrColor,
		opacity: hrOpacity,
	};
	return (
		<HeaderWithRuleContainer>
			<Hr {...hrProps} />
			<HeaderWithRuleText weight={textWeight} color={textColor} size={fontSize} el={el ?? HeaderElements.H2}>
				{children}
			</HeaderWithRuleText>
			<Hr {...hrProps} />
		</HeaderWithRuleContainer>
	);
};

export default HeaderWithRule;
